import React from 'react';
import Step from './Step';

const Stepper = ({steps}) => (
  <div>
    { steps?.map((step) => (
      <Step {...step} key={step.position}></Step>
    ))}
  </div>
);

export default Stepper;
